if (!customElements.get('vip-sticky-atc')) {
  customElements.define(
    'vip-sticky-atc',
    class VipStickyAtc extends HTMLElement {
      connectedCallback() {
        this.priceEl = this.querySelector('[data-vip-sticky-price]');
        const form = document.getElementById(this.dataset.formId);
        if (this.priceEl && form) {
          this.quantityInput = document.querySelector(`input[name="quantity"][form="${this.dataset.formId}"], #Quantity-${(form.dataset && form.dataset.sectionId) || ''}`) || document.querySelector('.quantity__input');
          if (this.quantityInput) {
            this.boundQty = () => this.updateTotal();
            this.quantityInput.addEventListener('change', this.boundQty);
            this.quantityInput.addEventListener('input', this.boundQty);
          }
        }
        /* Dawn declares PUB_SUB_EVENTS with `const` in constants.js, so it is a
           lexical binding and never becomes a property of `window`. Testing
           `window.PUB_SUB_EVENTS` therefore always failed and this
           subscription never registered. */
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event && event.data && event.data.variant;
            if (!variant) return;
            this.dataset.unitPrice = variant.price;
            if (this.priceEl) this.updateTotal();
            const atcPrice = document.querySelector('[data-vip-atc-price]');
            if (atcPrice) atcPrice.textContent = this.formatMoney(variant.price);
          });
        }
        const anchor = document.getElementById(this.dataset.anchor);
        if (!anchor || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              delete this.dataset.visible;
            } else {
              this.dataset.visible = '';
            }
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.observer.observe(anchor);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribeVariant) this.unsubscribeVariant();
        if (this.quantityInput && this.boundQty) {
          this.quantityInput.removeEventListener('change', this.boundQty);
          this.quantityInput.removeEventListener('input', this.boundQty);
        }
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        }).format(cents / 100);
      }

      updateTotal() {
        const unit = parseInt(this.dataset.unitPrice, 10);
        const qty = Math.max(1, parseInt(this.quantityInput && this.quantityInput.value, 10) || 1);
        if (!unit) return;
        this.priceEl.textContent = this.formatMoney(unit * qty);
      }
    }
  );
}
